import { blogPosts } from '../../../../mocks/blog-posts';

interface RelatedArticlesProps {
  currentSlug: string;
  currentCategory: string;
}

export default function RelatedArticles({ currentSlug, currentCategory }: RelatedArticlesProps) {
  const relatedPosts = blogPosts
    .filter(post => post.slug !== currentSlug && post.category === currentCategory)
    .slice(0, 3);

  if (relatedPosts.length === 0) return null;

  return (
    <section className="py-16 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-8 bg-[#C9A961] rounded-full"></div>
          <h2 className="text-3xl font-bold text-[#1A1F2E]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Related Articles
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {relatedPosts.map((post) => (
            <a
              key={post.id}
              href={`/travel-guides/${post.slug}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-[#1A1F2E]/80 text-white text-xs font-medium rounded-full">
                    {post.category}
                  </span>
                </div>
              </div>
              
              <div className="p-5">
                <h3 className="text-lg font-bold text-[#1A1F2E] mb-2 group-hover:text-[#C9A961] transition-colors line-clamp-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {post.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-2">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <span className="text-xs text-gray-600">{post.author}</span>
                  <span className="text-xs text-gray-500">{post.readTime}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
